// Which mobile bottom sheet is open (one at a time). MobileShell renders them all; each animates in
// and out on its own when this changes.
import { create } from 'zustand';

export type SheetKind = 'create' | 'profile' | 'settings' | 'inbox-tabs' | 'workspaces' | 'task-menu' | 'notepad' | 'mute' | 'invite';

export const useSheet = create<{ open: SheetKind | null; taskId: string | null }>(() => ({ open: null, taskId: null }));

export const openSheet = (open: SheetKind, taskId: string | null = null) => useSheet.setState({ open, taskId });
export const closeSheet = () => useSheet.setState({ open: null });
